import React from 'react';
import Link, { LINK_SIZES } from 'components/Link';
import PropTypes from 'prop-types';

const MarketAccessLinksColumn = ({ heading, links }) => (
  <div className="market-access-links-column">
    {heading && (
      <h3 className="market-access-links-column__heading">{heading}</h3>
    )}
    {links && links.length > 0 ? (
      <ul className="market-access-links-column__list">
        {links.map((link, index) => (
          <li className="market-access-links-column__item" key={index}>
            <Link
              {...link}
              size={LINK_SIZES.large}
              className="market-access-links-column__link"
            />
          </li>
        ))}
      </ul>
    ) : null}
  </div>
);

MarketAccessLinksColumn.propTypes = {
  heading: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.exact(Link.propTypes)),
};

export default MarketAccessLinksColumn;
